import * as React from "react";
const SvgCheckbox = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 1L4.5 7.5L1 4", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgCheckbox;
